import { theme } from '../../../../styles/theme';
import styled, { css } from 'styled-components';
import { HexColorPicker } from 'react-colorful';

export const Container = styled.div<{ $hasPlaceholder: boolean }>`
  padding: 8px;
  ${({ $hasPlaceholder }) =>
    $hasPlaceholder &&
    // CustomContainer_Height - ColorGridContainer_Height = 100px
    // this is the placeholder to avoid window debounce on height change in secondary menu
    // to test it, open the color select menu and switch between color and custom tabs
    css`
      margin-bottom: 100px;
    `}
`;

export const TabContentContainer = styled.div`
  padding: 8px 8px 0 8px;
`;

export const ColorGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 8px;
  width: 120px;
  height: 48px;
`;

export const ColorGridItem = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const Circle = styled.div<{ $color: string; $isSelected: boolean }>`
  position: relative;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};

  &::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border-radius: 50%;
    border: ${({ $isSelected }) =>
      $isSelected ? `2px solid ${theme.colors.secondary900}` : 'none'};
    pointer-events: none;
  }
`;

export const CustomColorContainer = styled.div`
  height: 148px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: auto;
`;
export const StyledHexColorPicker = styled(HexColorPicker)`
  & {
    .react-colorful__saturation {
      border-radius: 4px;
    }

    .react-colorful__pointer {
      width: 14px;
      height: 14px;
    }

    .react-colorful__last-control {
      margin-top: 8px;
      border-radius: 4px;
      height: 8px;
    }
  }
`;
